import Vue from 'vue';
import yourComponent from '@/components/login.vue';

export function openLogin(type) {
  const Task = Vue.extend(yourComponent);
  const taskvm = new Task({ data: { isRegister: type === 'register', type} });
  document.body.appendChild(taskvm.$mount().$el);
}

export function checkLogin() {
  const user_id = window.$nuxt?.$store?.state?.user?.userInfo?.id;
  if (!user_id) {
    openLogin();
    return false;
  }
  return true;
}
